import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/cancel.svg'
import _imports_1 from '@/assets/filterIcon.svg'


const _hoisted_1 = { class: "dashboard-page px-3 sm:px-5 pt-3 pb-2 mb-5" }
const _hoisted_2 = { class: "dashboard-header mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "applied-filters"
}
const _hoisted_4 = { class: "applied-filter-label" }
const _hoisted_5 = { class: "applied-filter-value" }
const _hoisted_6 = ["aria-label", "onClick"]
const _hoisted_7 = { class: "kpi-grid mb-4" }
const _hoisted_8 = { class: "kpi-label" }
const _hoisted_9 = { class: "kpi-value" }
const _hoisted_10 = { class: "chart-grid mb-4" }
const _hoisted_11 = { class: "card p-3 chart-card" }
const _hoisted_12 = {
  key: 0,
  class: "chart-body"
}
const _hoisted_13 = {
  key: 1,
  class: "no-data"
}
const _hoisted_14 = { class: "card p-3 chart-card" }
const _hoisted_15 = {
  key: 1,
  class: "no-data"
}
const _hoisted_16 = { class: "card p-3 chart-card" }
const _hoisted_17 = {
  key: 0,
  class: "chart-body"
}
const _hoisted_18 = {
  key: 1,
  class: "no-data"
}
const _hoisted_19 = { class: "card p-3 chart-card" }
const _hoisted_20 = {
  key: 0,
  class: "chart-body"
}
const _hoisted_21 = {
  key: 1,
  class: "no-data"
}
const _hoisted_22 = { class: "card p-4 chart-card chart-card-wide mb-4" }
const _hoisted_23 = {
  key: 0,
  class: "chart-body chart-body-wide"
}
const _hoisted_24 = {
  key: 1,
  class: "no-data"
}
const _hoisted_25 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_26 = { class: "relative w-full max-w-full sm:max-w-xl" }
const _hoisted_27 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_28 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_29 = { class: "impactcontainer popupbodycontainer flex-1 overflow-y-auto" }
const _hoisted_30 = { class: "formcontainer flex flex-col px-4 pb-4" }
const _hoisted_31 = { class: "grid grid-cols-1 md:grid-cols-2 gap-3 mt-4" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = ["max"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = ["min", "max"]
const _hoisted_36 = { class: "flex justify-end items-center pb-4 pl-5 pt-4 pr-5 border-t border-lightgrey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loader = _resolveComponent("loader")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_Select = _resolveComponent("Select")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.appliedFilterChips.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "applied-filters-heading" }, "Applied Filters:", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedFilterChips, (chip) => {
              return (_openBlock(), _createElementBlock("div", {
                key: chip.key,
                class: "applied-filter-chip"
              }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(chip.label) + ":", 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(chip.value), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "applied-filter-remove",
                  "aria-label": 'Remove ' + chip.label + ' filter',
                  onClick: ($event: any) => (_ctx.removeAppliedFilter(chip.key))
                }, [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1)
                ]))], 8, _hoisted_6)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "flex filterButton dashboard-filter-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
      }, [...(_cache[18] || (_cache[18] = [
        _createElementVNode("img", {
          src: _imports_1,
          class: "filterIcon",
          alt: ""
        }, null, -1),
        _createTextVNode(" Filters ", -1)
      ]))])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiCards, (kpi) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: kpi.key,
          class: _normalizeClass(["kpi-card text-left", 'kpi-card--' + kpi.tone]),
          to: _ctx.kpiRoute(kpi.key),
          onClick: _ctx.markTasksRoute
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, _toDisplayString(kpi.label), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(kpi.display), 1)
          ]),
          _: 2
        }, 1032, ["class", "to", "onClick"]))
      }), 128))
    ]),
    (_ctx.dataLoading)
      ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "card-title" }, "Task Status", -1)),
              (_ctx.hasStatusData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(), _createBlock(_component_apexchart, {
                      key: 'status-' + _ctx.chartKey,
                      type: "donut",
                      height: "280",
                      width: "100%",
                      options: _ctx.statusChartOptions,
                      series: _ctx.statusSeries
                    }, null, 8, ["options", "series"]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, "No data for selected filters"))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "card-title" }, "Tasks by Team", -1)),
              (_ctx.hasTeamData)
                ? (_openBlock(), _createElementBlock("div", {
                    class: "chart-body",
                    key: _ctx.teamChartRenderKey
                  }, [
                    _createVNode(_component_apexchart, {
                      type: "bar",
                      height: "280",
                      width: "100%",
                      options: _ctx.departmentChartOptions,
                      series: _ctx.departmentSeries
                    }, null, 8, ["options", "series"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, "No data for selected filters"))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "card-title" }, "Tasks by Framework", -1)),
              (_ctx.hasFrameworkData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_openBlock(), _createBlock(_component_apexchart, {
                      key: 'framework-' + _ctx.chartKey,
                      type: "bar",
                      height: "280",
                      width: "100%",
                      options: _ctx.frameworkChartOptions,
                      series: _ctx.frameworkSeries
                    }, null, 8, ["options", "series"]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, "No data for selected filters"))
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "card-title" }, "Overdue Aging (in days)", -1)),
              (_ctx.hasAgingData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_openBlock(), _createBlock(_component_apexchart, {
                      key: 'aging-' + _ctx.chartKey,
                      type: "bar",
                      height: "280",
                      width: "100%",
                      options: _ctx.agingChartOptions,
                      series: _ctx.agingSeries
                    }, null, 8, ["options", "series"]))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, "No overdue tasks"))
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "card-title" }, "Task Execution Trend", -1)),
            (_ctx.hasTrendData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (_openBlock(), _createBlock(_component_apexchart, {
                    key: 'trend-' + _ctx.chartKey,
                    type: "line",
                    height: "320",
                    width: "100%",
                    options: _ctx.trendChartOptions,
                    series: _ctx.trendSeries
                  }, null, 8, ["options", "series"]))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, "No data for selected filters"))
          ])
        ], 64)),
    (_ctx.showFilters)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.showFilters
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _cache[25] || (_cache[25] = _createElementVNode("h1", null, "Filters", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "float-right text-3xl",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCancelFilters && _ctx.onCancelFilters(...args)))
                    }, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "h-5 w-5 cursor-pointer",
                        alt: ""
                      }, null, -1)
                    ]))])
                  ]),
                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", null, [
                          _cache[26] || (_cache[26] = _createElementVNode("label", {
                            class: "controllabel",
                            for: "dashboard-time-period"
                          }, "Time Period", -1)),
                          _createVNode(_component_Select, {
                            id: "dashboard-time-period",
                            inputId: "dashboard-time-period",
                            modelValue: _ctx.filters.timePeriod,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.timePeriod) = $event)),
                            options: _ctx.timePeriodOptions,
                            optionLabel: "label",
                            optionValue: "value",
                            placeholder: "Select",
                            showClear: "",
                            appendTo: "self",
                            class: "w-full mt-1",
                            onChange: _ctx.onTimePeriodChange
                          }, null, 8, ["modelValue", "options", "onChange"])
                        ]),
                        (_ctx.isCustomTimePeriod)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _cache[27] || (_cache[27] = _createElementVNode("label", {
                                class: "controllabel",
                                for: "dashboard-from-date"
                              }, "From Date", -1)),
                              _withDirectives(_createElementVNode("input", {
                                id: "dashboard-from-date",
                                type: "date",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.fromDate) = $event)),
                                class: "inputboxstyling mt-1 w-full",
                                max: _ctx.filters.toDate || _ctx.maxDate,
                                onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                                onKeydown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
                              }, null, 40, _hoisted_33), [
                                [_vModelText, _ctx.filters.fromDate]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isCustomTimePeriod)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _cache[28] || (_cache[28] = _createElementVNode("label", {
                                class: "controllabel",
                                for: "dashboard-to-date"
                              }, "To Date", -1)),
                              _withDirectives(_createElementVNode("input", {
                                id: "dashboard-to-date",
                                type: "date",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.toDate) = $event)),
                                class: "inputboxstyling mt-1 w-full",
                                min: _ctx.filters.fromDate || undefined,
                                max: _ctx.maxDate,
                                onFocus: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                                onKeydown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
                              }, null, 40, _hoisted_35), [
                                [_vModelText, _ctx.filters.toDate]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                          _cache[29] || (_cache[29] = _createElementVNode("label", {
                            class: "controllabel",
                            for: "dashboard-task-status"
                          }, "Task Status", -1)),
                          _createVNode(_component_MultiSelect, {
                            inputId: "dashboard-task-status",
                            modelValue: _ctx.filters.taskStatus,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.taskStatus) = $event)),
                            options: _ctx.statusOptions,
                            optionLabel: "label",
                            dataKey: "id",
                            placeholder: "Select",
                            display: "chip",
                            maxSelectedLabels: 2,
                            appendTo: "self",
                            class: "w-full mt-1"
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[30] || (_cache[30] = _createElementVNode("label", {
                            class: "controllabel",
                            for: "dashboard-framework"
                          }, "Framework", -1)),
                          _createVNode(_component_MultiSelect, {
                            inputId: "dashboard-framework",
                            modelValue: _ctx.filters.framework,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filters.framework) = $event)),
                            options: _ctx.frameworkOptions,
                            optionLabel: "label",
                            dataKey: "value",
                            placeholder: "Select",
                            display: "chip",
                            filter: true,
                            maxSelectedLabels: 2,
                            appendTo: "self",
                            class: "w-full mt-1"
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[31] || (_cache[31] = _createElementVNode("label", {
                            class: "controllabel",
                            for: "dashboard-teams"
                          }, "Teams", -1)),
                          _createVNode(_component_MultiSelect, {
                            inputId: "dashboard-teams",
                            modelValue: _ctx.filters.departments,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters.departments) = $event)),
                            options: _ctx.departmentsList,
                            optionLabel: "label",
                            dataKey: "value",
                            placeholder: "Select",
                            display: "chip",
                            filter: true,
                            maxSelectedLabels: 2,
                            appendTo: "self",
                            class: "w-full mt-1"
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[32] || (_cache[32] = _createElementVNode("label", {
                            class: "controllabel",
                            for: "dashboard-locations"
                          }, "Location", -1)),
                          _createVNode(_component_MultiSelect, {
                            inputId: "dashboard-locations",
                            modelValue: _ctx.filters.locations,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters.locations) = $event)),
                            options: _ctx.locations,
                            optionLabel: "label",
                            dataKey: "value",
                            placeholder: "Select",
                            display: "chip",
                            filter: true,
                            maxSelectedLabels: 2,
                            appendTo: "self",
                            class: "w-full mt-1"
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[33] || (_cache[33] = _createElementVNode("label", {
                            class: "controllabel",
                            for: "dashboard-frequency"
                          }, "Frequency", -1)),
                          _createVNode(_component_MultiSelect, {
                            inputId: "dashboard-frequency",
                            modelValue: _ctx.filters.controlFrequency,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filters.controlFrequency) = $event)),
                            options: _ctx.dbFrequency,
                            optionLabel: "key",
                            dataKey: "value",
                            placeholder: "Select",
                            display: "chip",
                            maxSelectedLabels: 2,
                            appendTo: "self",
                            class: "w-full mt-1"
                          }, null, 8, ["modelValue", "options"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "filterButton mr-2",
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.applyResetFilters && _ctx.applyResetFilters(...args)))
                    }, "Reset"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btnprimary",
                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                    }, "Apply")
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}